export interface AvatarPlaceholderIconProps {
  placeholderLetter: string;
  colorClass?: AvatarPlaceholderColorClass;
  size?: AvatarSize;
  isRandomColor?: boolean;
  borderThickness?: AvatarBorderThickness;
}

export enum AvatarPlaceholderColorClass {
  PRIMARY_100 = 'bg-primary-100',
  SECONDARY_100 = 'bg-secondary-100',
  SUCCESS_100 = 'bg-success-100',
  DANGER_100 = 'bg-danger-100',
  PREMIUM_100 = 'bg-premium-100',
  NEUTRAL_80 = 'bg-neutral-80',
}

export enum AvatarSize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum AvatarBorderThickness {
  THIN = 'thin',
  THICK = 'thick',
}
